/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { HTMLProps } from "react";
import sass from "./counter.module.sass";

interface ICounterProps extends HTMLProps<HTMLInputElement> {
	plus: () => void;
	minus: () => void;
}

const Counter: React.FC<ICounterProps> = ({ onChange, plus, minus, ...props }) => {
	return (
		<div className={sass.wrapper}>
			<div onClick={minus} className={sass.minus}>
				<div />
			</div>
			<input
				onChange={(e) => {
					e.target.value = e.target.value.replace(/\D/g, "");
					if (onChange) onChange(e);
				}}
				className={sass.field}
				type="text"
				{...props}
			/>
			<div onClick={plus} className={sass.plus}>
				<div />
			</div>
		</div>
	);
};

export default Counter;
